import { __decorate, __metadata } from "tslib";
import { Component, Provide, Ref } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const SYM_LV_TAB_GROUP = Symbol("LvTabGroup");
export const COMPONENT_NAME = "LvTabGroup";
let LvTabGroup = class LvTabGroup extends UIComponent {
    constructor() {
        super(...arguments);
        this.children = [];
        this.current = null;
    }
    get self() {
        return this;
    }
    mounted() {
        this.setDefaultActive();
    }
    setDefaultActive() {
        const first = this.children[0];
        if (first)
            this.setCurrentTab(first);
    }
    setCurrentTab(tab) {
        this.current = tab;
        for (const c of this.children) {
            c.isActive = c == tab;
        }
    }
    registerChild(child) {
        this.children.push(child);
        this.groupHeader.appendChild(child.tabHeader);
    }
    unregisterChild(child) {
        if (!this.groupHeader)
            return;
        const idx = this.children.indexOf(child);
        if (idx > -1) {
            this.children.splice(idx, 1);
            this.groupHeader.removeChild(child.tabHeader);
        }
    }
};
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvTabGroup.prototype, "groupHeader", void 0);
__decorate([
    Provide(SYM_LV_TAB_GROUP),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvTabGroup.prototype, "self", null);
LvTabGroup = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvTabGroup);
export default LvTabGroup;
//# sourceMappingURL=script.js.map